enum TipoLogEntidade {
    FormaFarmaceutica = 1,
    Manipulacao = 2,
    ProdutoLote = 3,
    Produto = 4,
    SessaoCaixa = 5,
    Prescritor = 6,
    Usuario = 7,
    NotaFiscal = 8,
    Fornecedor = 9,
    Venda = 10,
    Cliente = 11,
    KitEmbalagem = 12,
    ConfiguracaoFranquia = 13,
    ConfiguracaoUsuario = 14,
    Franquia = 15,
    FormulaPadrao = 16,
    ConfiguracaoDotz = 17,
    Posologia = 18,
    ServicosFiscais = 19,
    NaturezaOperacao = 20,
    ConfiguracaoPCP = 21,
    ConfiguracaoImpressaoVenda = 22,
    ConfiguracaoImpressaoManipulacao = 23,
    ConfiguracaoImpressaoRotulo = 24,
    TipoVenda = 25,
    MovimentacaoEstoque = 26,
}

export default TipoLogEntidade;
